import React, {createContext, useReducer} from "react";
import PropTypes from "prop-types";


export const LOAD_UPSELL = 'domainconfig/LOAD_UPSELL'
export const SUCCESS_UPSELL = 'domainconfig/SUCCESS_UPSELL'
export const ERROR_UPSELL = 'domainconfig/ERROR_UPSELL'

export const SelectDomainConfigInitialState = {
    requestUpsellStatus: undefined,
    requestUpsellData: undefined,
    requestUpsellError: undefined
}
export default (state, action) => {
    switch (action.type) {
        case LOAD_UPSELL:
            return ({
                ...state,
                requestUpsellStatus: 'loading'
            })
        case SUCCESS_UPSELL:
            return ({
                ...state,
                requestUpsellStatus: 'success',
                requestUpsellData: action.requestUpsellData
            })
        case ERROR_UPSELL:
            return ({
                ...state,
                requestUpsellStatus: 'error',
                requestUpsellError: action.requestUpsellError
            })
        default:
            return state
    }
}
export const SelectDomainConfigContext = createContext()
export let SelectDomainConfigProvider = ({reducer, initialState, children, setDomainPage}) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    return (
        <SelectDomainConfigContext.Provider value={{
            state,
            dispatch,
            setDomainPage
        }}>
            {children}
        </SelectDomainConfigContext.Provider>
    )
}
SelectDomainConfigProvider.propTypes = {
    reducer: PropTypes.any,
    initialState: PropTypes.any,
    children: PropTypes.any,
    setDomainPage: PropTypes.func
}